import { createFileRoute } from "@tanstack/react-router";

import { AudiencesMainPage } from "@/features/Audiences/MainPage";
import { audienceListSearchSchema } from "@/features/Audiences/types";

export const Route = createFileRoute("/_auth/people/$siteId/audiences/")({
  validateSearch: (raw) => audienceListSearchSchema.parse(raw),
  component: AudiencesListRoute,
});

function AudiencesListRoute() {
  const { siteId } = Route.useParams();
  const search = Route.useSearch();

  return <AudiencesMainPage siteId={siteId} search={search} />;
}
